import React, { useState, useEffect } from "react";
import "./App.css";

export default function App() {
  const [city, setCity] = useState("");
  const [weather, setWeather] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [time, setTime] = useState(new Date());

  const API_KEY = "YOUR_API_KEY_HERE"; // 🔐 move to .env in real apps

  // Live Clock
  useEffect(() => {
    const interval = setInterval(() => {
      setTime(new Date());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const fetchWeather = async () => {
    if (!city) return;

    try {
      setLoading(true);
      setError("");

      const response = await fetch(
        `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${API_KEY}&units=metric`
      );

      if (!response.ok) throw new Error("City not found");

      const data = await response.json();
      setWeather(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const formattedDate = time.toDateString();
  const formattedTime = time.toLocaleTimeString();

  return (
    <div className="weather-wrapper">
      <div className="weather-card">

        <h1 className="app-title">🌤 Weather App</h1>

        {/* Date & Time */}
        <p className="date-text">{formattedDate}</p>
        <h2 className="time-text">{formattedTime}</h2>

        {/* Input */}
        <div className="input-group">
          <input
            type="text"
            className="city-input"
            placeholder="Enter city..."
            value={city}
            onChange={(e) => setCity(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && fetchWeather()}
          />
          <button className="search-btn" onClick={fetchWeather}>
            🔍
          </button>
        </div>

        {/* Loading */}
        {loading && <p className="loading">Loading...</p>}

        {/* Error */}
        {error && <p className="error">{error}</p>}

        {/* Weather Info */}
        {weather && (
          <div className="weather-info">
            <h3 className="city-name">
              {weather.name}, {weather.sys.country}
            </h3>

            <h1 className="temperature">
              {weather.main.temp}°C
            </h1>

            <p className="weather-condition">
              {weather.weather[0].main}
            </p>

            <div className="weather-stats">
              <div className="stat-box">
                <p>Humidity</p>
                <h4>{weather.main.humidity}%</h4>
              </div>

              <div className="stat-box">
                <p>Wind</p>
                <h4>{weather.wind.speed} m/s</h4>
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}